import { RecContentItemTypeDto } from '../apis/rec-gateway/rec-gateway.dtos';

export const assignableSimulationSubTypes = [
  RecContentItemTypeDto.VERBAL_REPORT_TEMPLATE,
  RecContentItemTypeDto.OBSERVER_EVALUATION_RUBRIC,
  RecContentItemTypeDto.PERFORMANCE_CHECKLIST,
];
